import { makeStyles } from '@material-ui/core';
import AudioSvg from 'assets/images/audio.svg';
import React, { ReactElement } from 'react';

const useStyles = makeStyles(() => ({
  logo: {
    width: '24px',
    height: '24px',
    objectFit: 'cover',
  },
}));

function Audio(): ReactElement {
  const classes: any = useStyles();
  return <img src={AudioSvg} alt="Audio icon" className={classes.logo} />;
}

export default Audio;
